import React from 'react';
type SectionProps = {
  tone: 'ink' | 'wine';
  id?: string;
  wide?: boolean;
  className?: string;
  children: React.ReactNode;
};
export function Section({
  tone,
  id,
  wide = false,
  className = '',
  children
}: SectionProps) {
  return <section id={id} className={`${tone === 'ink' ? 'bg-ink' : 'bg-wine'} py-14 md:py-24`} data-id="element-31" data-mp="3fxydkcck4kte">
      <div className={`mx-auto w-full ${wide ? 'max-w-[1040px]' : 'max-w-[720px]'} px-6 ${className}`} data-id="element-32" data-mp="3kw9oyrii33dq">
        {children}
      </div>
    </section>;
}
export function SectionTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h2 className={`font-serif text-[2.3rem] font-medium leading-[1.08] text-ivory md:text-[3.25rem] ${className}`} data-id="element-33" data-mp="2qn51yy6kj3i">
      {children}
    </h2>;
}